import { render, staticRenderFns } from "./GeneratedRewardsList.vue?vue&type=template&id=fcdfe04c&"
import script from "./GeneratedRewardsList.vue?vue&type=script&lang=js&"
export * from "./GeneratedRewardsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports